import Vue from 'vue'
import Router from 'vue-router'
import AppHome from '@/components/Home/AppHome'
import AppLogin from '@/components/Login/AppLogin'
import AppSignup from '@/components/Signup/AppSignup'
import AppCatalog from '@/components/Catalog/AppCatalog'
import CatalogCAT from '@/components/Catalog/CatalogCAT-SD'
import CatalogOrderBy from '@/components/Catalog/CatalogOrderBy'
import CatalogSortBy from '@/components/Catalog/CatalogSortBy'
import CatalogDCMSRF from '@/components/Catalog/CatalogDCMSRF'
import FAQ from '@/components/FAQ/FAQ'
import ContactUs from '@/components/ContactUs/ContactUs'
import Workspace from '@/components/Workspace/Workspace'
import MyProjects from '@/components/MyProjects/MyProjects'
import PublicProjects from '@/components/PublicProjects/PublicProjects'
import Settings from '@/components/Settings/Settings'
import Admin from '@/components/Admin/Admin'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'AppHome',
      component: AppHome
    },
    {
      path: '/method-catalog',
      name: 'AppCatalog',
      component: AppCatalog
    },
    {
      path: '/method-catalog/cat-sd',
      name: 'CatalogCAT',
      component: CatalogCAT
    },
    {
      path: '/method-catalog/orderby',
      name: 'CatalogOrderBy',
      component: CatalogOrderBy
    },
    {
      path: '/method-catalog/sortby',
      name: 'CatalogSortBy',
      component: CatalogSortBy
    },
    {
      path: '/method-catalog/dcmsrf',
      name: 'CatalogDCMSRF',
      component: CatalogDCMSRF
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/workspace',
      name: 'Workspace',
      component: Workspace
    },
    {
      path: '/login',
      name: 'AppLogin',
      component: AppLogin
    },
    {
      path: '/myprojects',
      name: 'Myprojects',
      component: MyProjects
    },
    {
      path: '/publicprojects',
      name: 'PublicProjects',
      component: PublicProjects
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin
    },
    {
      path: '/signup',
      name: 'AppSignup',
      component: AppSignup
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js